module.exports = __webpack_public_path__ + "static/media/boyd-logo.be8ad402.png";